import { render } from "./myHome-mobile.vue?vue&type=template&id=2aa46d25&scoped=true"
import script from "./myHome-mobile.vue?vue&type=script&lang=js"
export * from "./myHome-mobile.vue?vue&type=script&lang=js"

import "./myHome-mobile.vue?vue&type=style&index=0&id=2aa46d25&lang=less&scoped=true"

import exportComponent from "/Users/chenli/Documents/buzzbuzz/第九工场/my-project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aa46d25"]])

export default __exports__